var React = require('react');

function DownArrowInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M26.0961 14.0862H23.644C23.5047 14.0862 23.3715 14.1468 23.2777 14.2527L16.6508 21.8907V4.84375C16.6508 4.71055 16.5418 4.60156 16.4086 4.60156H14.5922C14.459 4.60156 14.35 4.71055 14.35 4.84375V21.8907L7.72318 14.2527C7.63236 14.1468 7.49916 14.0862 7.35687 14.0862H4.90473C4.69887 14.0862 4.58686 14.3314 4.72309 14.4858L14.7708 26.0654C14.8617 26.1702 14.974 26.2542 15.1001 26.3118C15.2262 26.3694 15.3633 26.3992 15.5019 26.3992C15.6406 26.3992 15.7777 26.3694 15.9038 26.3118C16.0299 26.2542 16.1422 26.1702 16.233 26.0654L26.2778 14.4858C26.414 14.3284 26.302 14.0862 26.0961 14.0862Z","fill":"var(--primary)"}));
}

DownArrowInline.defaultProps = {"width":"31","height":"31","viewBox":"0 0 31 31","fill":"none"};

module.exports = DownArrowInline;

DownArrowInline.default = DownArrowInline;
